export default "__VITE_ASSET__WWdgoS4N__"